export default __webpack_public_path__ + "static/media/react-icon.de53882c.svg";